
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.7.0
 * Query Engine version: 3cff47a7f5d65c3ea74883f1d736e41d68ce91ed
 */
Prisma.prismaVersion = {
  client: "6.7.0",
  engine: "3cff47a7f5d65c3ea74883f1d736e41d68ce91ed"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  plausible_id: 'plausible_id',
  isMedspotAdmin: 'isMedspotAdmin',
  avatar: 'avatar',
  backgroundPic: 'backgroundPic',
  firstName: 'firstName',
  lastName: 'lastName',
  profession: 'profession',
  specialite: 'specialite',
  etablissement: 'etablissement',
  hopital: 'hopital',
  service: 'service',
  status_pro: 'status_pro',
  medPoints: 'medPoints',
  rpps: 'rpps',
  referral: 'referral',
  followersCache: 'followersCache',
  subscriptionsCache: 'subscriptionsCache',
  web_push_subscriptions: 'web_push_subscriptions',
  native_push_subscriptions: 'native_push_subscriptions',
  badge_count: 'badge_count',
  forSearch: 'forSearch',
  otp: 'otp',
  otpCreatedAt: 'otpCreatedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastLoginAt: 'lastLoginAt',
  lastSeenAt: 'lastSeenAt',
  deletedAt: 'deletedAt',
  verifiedAt: 'verifiedAt'
};

exports.Prisma.FollowerScalarFieldEnum = {
  id: 'id',
  masterId: 'masterId',
  slaveId: 'slaveId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BlockedScalarFieldEnum = {
  id: 'id',
  masterId: 'masterId',
  slaveId: 'slaveId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LinkMetadataScalarFieldEnum = {
  id: 'id',
  url: 'url',
  image: 'image',
  imageAlt: 'imageAlt',
  description: 'description',
  publisher: 'publisher',
  title: 'title',
  domain: 'domain',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PostScalarFieldEnum = {
  id: 'id',
  status: 'status',
  isComment: 'isComment',
  authorId: 'authorId',
  roomId: 'roomId',
  content: 'content',
  profession: 'profession',
  author_notified: 'author_notified',
  postReferenceId: 'postReferenceId',
  anonymous: 'anonymous',
  imageUrl: 'imageUrl',
  attachments: 'attachments',
  linkMetadataId: 'linkMetadataId',
  seen: 'seen',
  likes: 'likes',
  favs: 'favs',
  reportedBy: 'reportedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  pollId: 'pollId'
};

exports.Prisma.LikeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  postId: 'postId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SeenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  postId: 'postId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FavoriteScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  postId: 'postId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QuotedUsersInPostScalarFieldEnum = {
  id: 'id',
  quotingPostId: 'quotingPostId',
  quotedUserId: 'quotedUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserStatusScalarFieldEnum = {
  status: 'status',
  room: 'room'
};

exports.Prisma.UserSpecialiteScalarFieldEnum = {
  specialite: 'specialite',
  room: 'room'
};

exports.Prisma.RoomNameScalarFieldEnum = {
  roomName: 'roomName'
};

exports.Prisma.UserRoomScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  roomId: 'roomId',
  avatar: 'avatar',
  name: 'name',
  lastVisitAt: 'lastVisitAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RoomScalarFieldEnum = {
  id: 'id',
  name: 'name',
  manualName: 'manualName',
  etablissement: 'etablissement',
  roomType: 'roomType',
  lastMessageAt: 'lastMessageAt',
  numberOfUsers: 'numberOfUsers',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EtablissementScalarFieldEnum = {
  name: 'name',
  hopitaux: 'hopitaux',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationLogScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  url: 'url',
  title: 'title',
  body: 'body',
  icon: 'icon',
  read_at: 'read_at',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.PollScalarFieldEnum = {
  id: 'id',
  postId: 'postId',
  authorId: 'authorId',
  name: 'name',
  option1: 'option1',
  option2: 'option2',
  option3: 'option3',
  option4: 'option4',
  option5: 'option5',
  votes1: 'votes1',
  votes2: 'votes2',
  votes3: 'votes3',
  votes4: 'votes4',
  votes5: 'votes5',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserPollScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  pollId: 'pollId',
  postId: 'postId',
  optionNumber: 'optionNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CronJobScalarFieldEnum = {
  id: 'id',
  unique_key: 'unique_key',
  name: 'name',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.Profession = exports.$Enums.Profession = {
  MEDECIN: 'MEDECIN',
  INFIRMIER: 'INFIRMIER'
};

exports.PostStatus = exports.$Enums.PostStatus = {
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED'
};

exports.RoomType = exports.$Enums.RoomType = {
  ETABLISSEMENT: 'ETABLISSEMENT',
  SPECIALITE: 'SPECIALITE',
  STATUS_PRO: 'STATUS_PRO',
  DIRECT: 'DIRECT',
  SPECIALITE_AND_STATUS_PRO: 'SPECIALITE_AND_STATUS_PRO',
  UNIVERSITAIRE: 'UNIVERSITAIRE'
};

exports.Prisma.ModelName = {
  User: 'User',
  Follower: 'Follower',
  Blocked: 'Blocked',
  LinkMetadata: 'LinkMetadata',
  Post: 'Post',
  Like: 'Like',
  Seen: 'Seen',
  Favorite: 'Favorite',
  QuotedUsersInPost: 'QuotedUsersInPost',
  UserStatus: 'UserStatus',
  UserSpecialite: 'UserSpecialite',
  RoomName: 'RoomName',
  UserRoom: 'UserRoom',
  Room: 'Room',
  Etablissement: 'Etablissement',
  NotificationLog: 'NotificationLog',
  Poll: 'Poll',
  UserPoll: 'UserPoll',
  CronJob: 'CronJob'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
